import React, { useMemo } from 'react';

import FormBtnInnerX from '/assets/icon/global/form-btn-inner-x.svg';
import FormBtnInnerSearch from '/assets/icon/global/form-btn-inner-search.svg';

interface IProps {
  label?: string;
  name: string;
  id?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  style?: React.CSSProperties;
  defaultValue?: string;

  placeholder?: string;
  disabled?: boolean;
  readOnly?: boolean;
  required?: boolean;
  maxLength?: number;
  error?: string;
  onKeyDown?: (value: string, e: React.KeyboardEvent<HTMLInputElement>) => void;
  isBtnClose?: boolean;
  isBtnSearch?: boolean;
  onSearchAction?: any;
}

const CustomText = (props: IProps) => {
  const [inputValue, setInputValue] = React.useState<string>(props.value || '');

  React.useEffect(() => {
    if (props.value) {
      setInputValue(props.value);
    } else {
      let defaultValue = props.defaultValue;
      if (defaultValue) {
        setInputValue(defaultValue);
      } else {
        setInputValue('');
      }
      props.onChange?.({
        target: {
          name: props.name ?? '',
          value: defaultValue ?? ''
        }
      } as unknown as React.ChangeEvent<HTMLInputElement>);
    }
  }, [props.value]);

  const handleOnchange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
    props.onChange?.(e);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if ((e.nativeEvent as any).isComposing || (e as any).keyCode === 229) return;
    if (e.key === 'Enter') {
      props.onKeyDown?.((e.currentTarget as HTMLInputElement).value, e);
    }
  };

  const clear = () => {
    setInputValue('');
    props.onChange?.({
      target: {
        name: props.name ?? '',
        value: ''
      }
    } as unknown as React.ChangeEvent<HTMLInputElement>);
  };

  const paddingRight = useMemo(() => {
    let px = 10;
    if (props.isBtnClose) px += 30;
    if (props.isBtnSearch) px += 30;
    return px;
  }, [props.isBtnSearch, props.isBtnClose]);

  return (
    <div className={`custom-text ${props.className || ''} `} style={props.style}>
      {props.label && <label htmlFor={props.id}>{props.label}</label>}
      <div style={{ display: 'flex', flex: '1', position: 'relative' }}>
        <input
          id={props.id}
          name={props.name}
          type={'text'}
          placeholder={props.placeholder}
          value={inputValue}
          onChange={handleOnchange}
          disabled={props.disabled}
          readOnly={props.readOnly}
          required={props.required}
          maxLength={props.maxLength}
          onKeyDown={handleKeyDown}
          style={{ padding: '10px 10px 10px 10px', paddingRight: paddingRight }}
        />
        {(props.isBtnSearch || props.isBtnClose) && (
          <div className={'inner-btn-area'}>
            {props.isBtnClose && (
              <a
                className={'inner-btn-close'}
                onClick={() => {
                  clear();
                }}
              >
                <img src={FormBtnInnerX} alt={'close'} />
              </a>
            )}

            {props.isBtnSearch && (
              <a
                className={'inner-btn-search'}
                onClick={() => {
                  console.log('onSearchAction');
                  if (props.onSearchAction) {
                    props.onSearchAction();
                  }
                }}
              >
                <img src={FormBtnInnerSearch} alt={'search'} />
              </a>
            )}
          </div>
        )}
      </div>

      {props.error && <div className="error-text">{props.error}</div>}
    </div>
  );
};

export default CustomText;
